"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var styled_components_1 = __importDefault(require("styled-components"));
var StyledContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* .lagom-container */\n  max-width: var(\n    --lagom-component-container-width,\n    ", "\n  );\n  margin: 0 auto;\n  margin-bottom: var(--lagom-component-container-margin-bottom, 8rem);\n\n  &.lagom-container--margin-none {\n    margin-bottom: unset;\n  }\n"], ["\n  /* .lagom-container */\n  max-width: var(\n    --lagom-component-container-width,\n    ", "\n  );\n  margin: 0 auto;\n  margin-bottom: var(--lagom-component-container-margin-bottom, 8rem);\n\n  &.lagom-container--margin-none {\n    margin-bottom: unset;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.sizes.maxWidthContainer;
});
/**
 * Primarily used as a child of `Section`. Provides a container for the section contents.
 */
var Container = function (_a) {
    var children = _a.children, className = _a.className, marginNone = _a.marginNone, restProps = __rest(_a, ["children", "className", "marginNone"]);
    return ((0, jsx_runtime_1.jsx)(StyledContainer, __assign({ className: (0, clsx_1.default)("lagom-container", className, marginNone && "lagom-container--margin-none") }, restProps, { children: children })));
};
exports.Container = Container;
var templateObject_1;
//# sourceMappingURL=Container.js.map